


























































































































































































































import Scope from '@/views/atoms/Scope.vue'
import Episode4Popup from '@/views/templates/africadogs/atoms/Episode4Popup.vue'
export default
  components: {
    Scope
    Episode4Popup
  }
  data: () ->
    menuList: [
      [
        'オープニング'
        'セッション'
      ]
      [
        '第1工程'
        '糊付け体験'
      ]
      [
        'クロージング'
        'トークセッション'
      ]
      [
        '第2工程'
        '糊割り体験'
      ]
      [
        '第2工程'
        '染め体験'
      ]
      [
        '待ちに待った'
        '仕上り！'
      ]
    ]
    activeIndex: 0
    scrollLeft: 0
    scrollLeftSP: 0
    showOriginPopup: false
  methods:
    selectMenu: (i) ->
      @scrollLeft = -(1020 * i)
      @activeIndex = i
    selectMenuSP: (i) ->
      @scrollLeftSP = -(90 * i)
      @activeIndex = i
    showPopup: () ->
      @showOriginPopup = true
